export default class ClientUtils {}

export enum ClientGender {
  MALE = 'Monsieur',
  FEMALE = 'Madame'
}

export enum CurrencySymbol {
  EURO = '€',
  DOLLAR = '$'
}


export function isCurrencySymbolFirst(
  symbol: string,
  language: string
): boolean {
  return language !== 'fr' || symbol === CurrencySymbol.DOLLAR;
}

export enum PricingPlan {
  'Bronze' = '500000',
  'Silver' = '1000000',
  'Gold' = '2000000',
  'Platinum' = '3000000'
}

export enum PoliciesMode {
  CLIENTS = 'clients',
  POLICIES = 'policies'
}
